<template>
  <div class="main">
    <Header :title="title" />
    <div class="container my-con">
      <div class="card">
        <h2 class="title">
          {{ title }}
        </h2>
        <base-info :base-info="reportInfo" />
        <item-detail title-text="报告附件">
          <template>
            <div class="content">
              <van-swipe>
                <van-swipe-item
                  v-for="(item, index) in picUrls"
                  :key="index"
                >
                  <div
                    style="
                      position: absolute;
                      z-index: 99;
                      background-color: #169bd5;
                      color: white;
                    "
                  >
                    {{
                      item.position === 1
                        ? "左侧"
                        : item.position === 2
                          ? "右侧"
                          : "未知"
                    }}
                  </div>
                  <van-image
                    :src="basePicUrl + item.url"
                    @click="seeImg(basePicUrl + item.url)"
                    alt=""
                  />
                </van-swipe-item>
              </van-swipe>
            </div>
          </template>
        </item-detail>
        <item-detail title-text="超声所见">
          <template>
            <!-- 数据来源：阅片(AIBUS)-专家版 -->
            <div
              class="content"
              v-if="resultPic.aibusTem === 2"
            >
              <p
                v-if="aibusTem2Result"
                v-html="aibusTem2Result"
              />
            </div>
            <!-- 数据来源：两癌或阅片标准版 -->
            <div
              class="content"
              v-else
            >
              <div v-if="leftResult">
                <span class="label">左侧乳房：</span>
                <p v-html="leftResult" />
              </div>
              <div v-if="rightResult">
                <span class="label">右侧乳房：</span>
                <p v-html="rightResult" />
              </div>
              <!-- 阅片标准版-更多信息 -->
              <p
                v-if="moreInfomation"
                v-html="moreInfomation"
              />
            </div>
          </template>
        </item-detail>
        <item-detail
          v-if="resultPic && resultPic.left && resultPic.lymphaden"
          title-text="可疑淋巴结"
        >
          <template>
            <!-- 数据来源：阅片(AIBUS)-专家版 -->
            <div class="content">
              <p v-html="resultPic.lymphaden" />
            </div>
          </template>
        </item-detail>
        <item-detail title-text="超声提示">
          <template>
            <!-- 数据来源：阅片(AIBUS)-专家版 -->
            <div
              class="content"
              v-if="resultPic.aibusTem === 2"
            >
              <!-- 数据来源：阅片(AIBUS)-专家版 -->
              <p
                v-if="resultPic.aibusTem === 2 && aibusTem2Notice"
                v-html="aibusTem2Notice"
              />
            </div>
            <!-- 数据来源：两癌或阅片标准版 -->
            <div class="content">
              <!-- 数据来源：两癌 -->
              <p
                v-if="
                  resultPic && resultPic.leftdata && resultPic.leftdata.BI_RADS
                "
              >
                <span class="label">左侧乳房：</span>BI_RADS
                {{
                  formatBI_RADS(resultPic && resultPic.leftdata)
                }}{{ notice.left && "(" + notice.left + ")" }}
                <span v-if="resultPic.leftdata.other" style="margin-left: 4px;"> 其他：{{resultPic.leftdata.other}}</span>
              </p>
              <!-- 数据来源：阅片(AIBUS)-标准版  -->
              <p
                v-if="resultPic && resultPic.left"
                v-html="notice.left"
              />
              <!-- 数据来源：两癌 -->
              <p
                v-if="
                  resultPic &&
                    resultPic.rightdata &&
                    resultPic.rightdata.BI_RADS
                "
              >
                <span class="label">右侧乳房：</span>BI_RADS
                {{
                  formatBI_RADS(resultPic && resultPic.rightdata)
                }}{{ notice.right && "(" + notice.right + ")" }}
                <span v-if="resultPic.rightdata.other" style="margin-left: 4px;"> 其他：{{resultPic.rightdata.other}}</span>
              </p>
              <!-- 数据来源：阅片(AIBUS)-标准版 -->
              <p
                v-if="resultPic && resultPic.right"
                v-html="notice.right"
              />
            </div>
          </template>
        </item-detail>
        <item-detail
          v-if="resultPic && resultPic.left && resultPic.clinicalImpression"
          title-text="临床印象"
        >
          <template>
            <!-- 数据来源：阅片(AIBUS)-专家版 -->
            <div class="content">
              <p
                v-for="(item, index) in clinicalImpressionList"
                :key="index"
              >
                {{ item }}
              </p>
            </div>
          </template>
        </item-detail>
        <!-- 数据来源：阅片(AIBUS)-专家版 -->
        <item-detail
          v-if="resultPic.aibusTem === 2 && resultPic.aibusTem"
          title-text="双侧肢窝探查"
        >
          <template>
            <div class="content">
              <div v-html="resultPic.aiArmpit" />
            </div>
          </template>
        </item-detail>
        <item-detail title-text="">
          <template>
            <div class="doctor-message">
              <div>检查医院：{{ reportInfo.biradsHospitalName }}</div>
              <!-- 数据来源：阅片(AIBUS)-标准版  -->
              <div v-if="resultPic && resultPic.left">
                检查医师：{{ resultPic.examDoctor }}
              </div>
              <div v-else>
                检查医师：{{ reportInfo.biradsDoctorName }}
              </div>
            </div>
          </template>
        </item-detail>
      </div>
      <div class="card">
        <van-cell
          title="报告解读"
          is-link
          @click="reportInterpretation"
        />
        <div class="message">
          总体评估采取BI-RADS分级，ACR.2013 BI-RADS第五版
        </div>
      </div>
      <div class="card">
        <van-cell
          title="用户资料"
          is-link
          @click="viewUserData"
        />
      </div>
      <van-overlay :show="loading">
        <div class="loading-box">
          <van-loading>加载中...</van-loading>
        </div>
      </van-overlay>
    </div>
  </div>
</template>

<script>
import Header from '@/components/header'
import baseInfo from '@/components/baseInfo'
import itemDetail from '@/components/ItemDetail'
import {
  Cell,
  Image,
  ImagePreview,
  Loading,
  Overlay,
  Swipe,
  SwipeItem
} from 'vant'
import { deepJsonParse } from '@/utils/handleJSON'

export default {
  components: {
    Header,
    baseInfo,
    itemDetail,
    [Cell.name]: Cell,
    [Image.name]: Image,
    [Loading.name]: Loading,
    [Overlay.name]: Overlay,
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem
  },
  data () {
    return {
      title: '乳腺超声检查报告',
      reportInfo: {
        name: '',
        sex: '',
        age: '',
        date: '',
        id: ''
      },
      resultPic: {
        leftdata: {},
        rightdata: {},
        aibusTem: 1
      },
      notice: {
        left: '',
        right: ''
      }, // 阅片标准版 超声提示
      leftResult: '', // 阅片标准版 超声所见 左侧
      rightResult: '', // 阅片标准版 超声所见 右侧
      aibusTem2Result: '', // 阅片专家版 超声所见
      aibusTem2Notice: '', // 阅片专家版 超声提示
      moreInfomation: '', // 更多信息
      clinicalImpressionList: [], // 临床印象
      picUrls: [],
      loading: false,
      basePicUrl: this.$imgUrl
    }
  },
  created () {
    this.getData()
  },
  methods: {
    async getData () {
      this.loading = true
      // 获取报告详情
      const { data } = await this.$api.personal.getReportDetail({
        id: this.$route.params.id
      })
      this.loading = false
      const { biradsDate, registerDate, resultPic, ...detail } = data
      // 获取超声提示、超声提示相关数据-this.resultPic
      this.resultPic = deepJsonParse(resultPic) || {
        leftdata: {},
        rightdata: {}
      }
      // this.resultPic.left存在 => 数据来源于阅片(AIBUS)
      // this.resultPic.leftdata存在 => 数据来源于两癌
      if (this.resultPic.left) {
        // 超声图片服务器单独处理
        this.basePicUrl = this.$aibusUrl
        // aibusTem === 1 标准版, 左右侧通过4个@@@@来分隔 3 长沙版
        if (this.resultPic.aibusTem === 2) {
          this.aibusTem2Result = this.resultPic.results
          this.aibusTem2Notice = this.resultPic.notices
        } else {
          this.clinicalImpressionList =
            this.resultPic.clinicalImpression.split('@@@@')
          // 阅片(AIBUS)超声所见
          this.leftResult = this.resultPic.results.split('@@@@')[0]
          this.rightResult = this.resultPic.results.split('@@@@')[1] || ''
          // 阅片(AIBUS)更多信息
          this.moreInfomation = this.resultPic.results.split('@@@@')[2] || ''
          // 阅片(AIBUS)超声提示
          this.notice.left = this.resultPic.notices.split('@@@@')[0]
          this.notice.right = this.resultPic.notices.split('@@@@')[1] || ''
        }
        this.resultPic.img_left = this.resultPic.img_left.split(',')
        if (
          Array.isArray(this.resultPic.img_left) &&
          this.resultPic.img_left.length > 0
        ) {
          this.resultPic.img_left.map((item) => {
            this.picUrls.push({
              url: item,
              position: 1
            })
          })
        }
        this.resultPic.img_right = this.resultPic.img_right.split(',')
        if (
          Array.isArray(this.resultPic.img_right) &&
          this.resultPic.img_right.length > 0
        ) {
          this.resultPic.img_right.map((item) => {
            this.picUrls.push({
              url: item,
              position: 2
            })
          })
        }
      } else {
        // 两癌超声所见
        if (this.resultPic.leftdata.BI_RADS == '1级') { this.leftResult = '乳腺内未探及肿块。' } else this.leftResult = this.handle(this.resultPic.leftdata)
        if (this.resultPic.rightdata.BI_RADS == '1级') { this.rightResult = '乳腺内未探及肿块。' } else this.rightResult = this.handle(this.resultPic.rightdata)
        // 两癌超声提示
        this.notice.left = this.viewNotice(
          this.resultPic.leftdata && this.resultPic.leftdata.BI_RADS
        )
        this.notice.right = this.viewNotice(
          this.resultPic.rightdata && this.resultPic.rightdata.BI_RADS
        )
        // 过滤得到超声图片
        this.picUrls = data.pictures
          .filter((item) => item.picType === 2)
          .map((item) => {
            return {
              url: item.picUrl,
              position: item.position
            }
          })
      }
      console.log(this.resultPic)
      detail.date = biradsDate || registerDate
      this.reportInfo = detail
    },
    viewNotice (level) {
      switch (level) {
        case '0级':
          return '可疑'
        case '1级':
          return ''
        case '2级':
          return ''
        case '3级':
          return '可疑'
        case '4级':
          return '阳性'
        case '5级':
          return '阳性'
        default:
          return ''
      }
    },
    formatBI_RADS (data) {
      if (
        !data ||
        data.BI_RADS === null ||
        typeof data.BI_RADS === 'undefined' ||
        data.BI_RADS === ''
      ) {
        return ''
      }
      let result = String(data.BI_RADS)
      let BI_RADS_ABC = ''
      if (
        data.BI_RADS_ABC !== null &&
        typeof data.BI_RADS_ABC !== 'undefined' &&
        data.BI_RADS_ABC !== ''
      ) {
        BI_RADS_ABC = String(data.BI_RADS_ABC).toLowerCase()
      }
      if (
        parseInt(result, 10) === 4 &&
        BI_RADS_ABC
      ) {
        result = result.replace(/^4([级类])$/, `4${BI_RADS_ABC}$1`)
      }
      return result
    },
    viewUserData () {
      this.$router.push(`/jcbg/${this.reportInfo.id}`)
    },
    reportInterpretation () {
      this.$router.push('/bgDetails')
    },
    handle (obj) {
      if (!obj) return
      let res = ''
      if (obj.cutbreast === '已切除乳房') {
        res = '已切除'
      } else {
        if (
          obj.nangzhong === '无' &&
          obj.zhongkuai === '无' &&
          obj.ruxianzengsheng === '无' &&
          obj.daoguankuozhang === '无' &&
          obj.linbajiezhongda === '无' &&
          obj.jiati === '无'
        ) {
          res = '无异常情况'
        } else {
          // 囊肿
          if (obj.nangzhong === '单纯囊肿' || obj.nangzhong === '复杂囊肿') {
            if (obj.nangzhong_reamark) {
              res += `${obj.nangzhong}(${obj.nangzhong_reamark})；`
            } else {
              res += obj.nangzhong + '；'
            }
          }
          // 肿块---除肿块（以及相关选项）、大小（以及相关选项）、BIRADS分级必填外，都是选填，需要判断其字段是否存在
          if (obj.zhongkuai === '单发' || obj.zhongkuai === '多发') {
            res += obj.zhongkuai + '；'
            obj.zhongkuai_items.forEach((item, index) => {
              res += `【肿块${index + 1}：部位（${item.buwei}${
                item.shizhongfa
                  ? '，' +
                    (item.shizhongfa === '区间'
                      ? item.shizhongfa_area1 + '~' + item.shizhongfa_area2
                      : item.shizhongfa)
                  : ''
              }${item.xiangxianfa ? '，' + item.xiangxianfa+'象限' : ''}${
                item.distance ? '，距离乳头' + item.distance + 'mm' : ''
              } ，大小(${
                item.daxiao === '可测量'
                  ? `${item.zhongkuaituankuai_zuida1} mm X ${item.zhongkuaituankuai_zuida2} mm`
                  : '不可测量'
              })${item.xingtai ? `，形态(${item.xingtai})` : ''}${
                item.fangxiang ? `，方向(${item.fangxiang})` : ''
              }${item.bianjie ? `，边界(${item.bianjie})` : ''}${
                item.bianyuan ? `，边缘(${item.bianyuan})` : ''
              }${
                item.huishengxingzhi
                  ? `，内部回声性质(${item.huishengxingzhi})`
                  : ''
              }${
                item.huishengfenbu
                  ? `，内部回声分布(${item.huishengfenbu})`
                  : ''
              } ${
                item.houfanghuisheng
                  ? `，后方回声(${item.houfanghuisheng})`
                  : ''
              }${item.gaihuazao ? `，钙化灶(${item.gaihuazao})` : ''}${
                item.xueliu ? `，血流(${item.xueliu})` : ''
              }${item.item_other ? `，其他(${item.item_other})` : ''}】；`
            })
          }
          // 乳腺增生
          if (obj.ruxianzengsheng === '有') {
            if (obj.ruxianzengsheng_other) {
              res += `乳腺增生(有, ${obj.ruxianzengsheng_other})；`
            } else {
              res += '乳腺增生(有)；'
            }
          }
          // 导管扩张
          if (obj.daoguankuozhang === '有') {
            if (obj.daoguankuozhang_other) {
              res += `导管扩张(有, ${obj.daoguankuozhang_other})；`
            } else {
              res += '导管扩张(有)；'
            }
          }
          // 淋巴结肿大
          if (obj.linbajiezhongda === '有') {
            if (obj.linbajiezhongda_other) {
              res += `淋巴结肿大(有, ${obj.linbajiezhongda_other})；`
            } else {
              res += '淋巴结肿大(有)；'
            }
          }
          // 假体
          if (obj.jiati === '有') {
            if (obj.jiati_other) {
              res += `假体(有, ${obj.jiati_other})；`
            } else {
              res += '假体(有)；'
            }
          }
        }
      }
      return res
    },
    seeImg (url) {
      ImagePreview({
        images: [url],
        showIndex: false
      })
    }
  }
}
</script>

<style scoped lang="less">
.container {
  font-size: 0.32rem;
  background-color: #f7f7f7;
  .card {
    background-color: white;
    margin-bottom: 0.2rem;
  }
  h2 {
    padding: 15px 0;
    font-size: 0.44rem;
    font-weight: 400;
    text-align: center;
  }
  .content {
    font-size: 0.28rem;
    div {
      margin-bottom: 20px;
    }
    p {
      margin-top: 10px;
    }
    .label {
      color: #aeaeae;
    }
  }
  .doctor-message {
    font-size: 0.28rem;
    display: flex;
    justify-content: space-between;
  }

  .message {
    padding: 10px;
    font-size: 0.2rem;
  }
  .loading-box {
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    .van-loading__text {
      color: #ffffff;
    }
    .van-loading {
      color: #ffffff;
    }
  }
}
</style>
